export default function SectionContact() {
  return (
    <section id="contact" className="bg-background-50 py-14 md:py-20">
      <div className="w-full px-4 md:px-6 max-w-[960px] mx-auto">
        <div className="bg-background-50 border border-background-200 rounded-2xl p-8 md:p-12 text-center">
          <div className="w-16 h-16 rounded-2xl bg-accent-100 flex items-center justify-center mx-auto mb-6">
            <i className="ri-mail-send-line text-accent-600 text-2xl"></i>
          </div>
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">联系我们</h2>
          <p className="text-sm text-foreground-500 mb-8 max-w-md mx-auto leading-relaxed">
            如果您对91麻豆免费视频网站有任何建议、意见或合作意向，
            欢迎通过以下方式联系我们。我们的团队将在24小时内回复。
          </p>
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="mailto:contact@91madou.example.com"
              className="inline-flex items-center gap-2 px-6 py-3 bg-primary-500 hover:bg-primary-600 text-white font-medium rounded-full transition-all duration-200 text-sm whitespace-nowrap cursor-pointer"
            >
              <i className="ri-mail-line text-lg"></i>
              发送邮件
            </a>
            <div className="flex items-center gap-2 px-6 py-3 bg-background-100 border border-background-200 rounded-full text-sm text-foreground-600">
              <i className="ri-customer-service-line text-lg text-primary-500"></i>
              客服热线：400-XXX-XXXX
            </div>
          </div>
          <p className="text-xs text-foreground-500 mt-6">工作日 9:00-18:00 在线服务</p>
        </div>
      </div>
    </section>
  );
}